import { render, staticRenderFns } from "./company_detail.vue?vue&type=template&id=69cfb5e7&scoped=true"
import script from "./company_detail.vue?vue&type=script&lang=js"
export * from "./company_detail.vue?vue&type=script&lang=js"
import style0 from "./company_detail.vue?vue&type=style&index=0&id=69cfb5e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfb5e7",
  null
  
)

export default component.exports